import { Card, CardContent, Typography, Chip, Box } from '@mui/material';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

export interface FeatureCardProps {
  title: string;
  description?: string;
  icon: ReactNode;
  badge?: string;
  path?: string;
  externalUrl?: string;
  onClick?: () => void;
  useIconColor?: boolean;
  showBorder?: boolean;
}

export const FeatureCard = ({ title, description, icon, badge, path, externalUrl, onClick, useIconColor = false, showBorder = false }: FeatureCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (externalUrl) {
      window.location.href = externalUrl;
    } else if (path) {
      navigate(path);
    }
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        ...(showBorder && { borderLeft: (theme) => `4px solid ${theme.palette.secondary.main}` }),
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 3,
        },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
          <Box sx={{ color: useIconColor ? 'inherit' : 'secondary.main', display: 'flex', alignItems: 'center' }}>{icon}</Box>
          {badge && (
            <Chip
              label={badge}
              size='small'
              sx={{
                fontWeight: 400,
                fontSize: '13px',
                backgroundColor: 'rgba(143, 40, 129, 0.04)',
                border: '1px solid #69075c',
                color: '#69075c',
              }}
            />
          )}
        </Box>
        <Typography variant='h6' component='h3' sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
            {description}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
